import React from "react";
import "./Loader.css";

export const Loader = ({ full, message }) => {
  return (
    <div
      className={`flex justify-center items-center w-[100%] ${
        !full && "h-[100vh]"
      }`}
    >
      <div className="lds-ripple z-[999]">
        <div></div>
        <div></div>
      </div>
    </div>
  );
};
